export default __webpack_public_path__ + "navigation-examples-custom-server-960-d0a39846e4ea1ccd385a1f0be407d7e5.png";